import { combineReducers } from "redux";
import productdetails from "../features/admin/product/productdetails/Slice";

const product = combineReducers({
  productdetails: productdetails,
});

export default product;
